"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchAvailableDepartures = void 0;

var _formik = require("formik");

var _react = require("react");

var _usehooksTs = require("usehooks-ts");

var _constants = require("../constants");

var _apiContext = require("../../../context/apiContext");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useFetchAvailableDepartures = function useFetchAvailableDepartures(options, isMobile) {
  var _useField = (0, _formik.useField)(_constants.FIELD_NAMES.destination),
      _useField2 = _slicedToArray(_useField, 1),
      destinationValue = _useField2[0].value;

  var _useState = (0, _react.useState)(options),
      _useState2 = _slicedToArray(_useState, 2),
      optionsWithAvailability = _useState2[0],
      setOptionsWithAvailability = _useState2[1];

  var isMounted = (0, _usehooksTs.useIsMounted)();
  var api = (0, _apiContext.useGetApiClient)();
  (0, _react.useEffect)(function () {
    if (destinationValue &&
    /* TODO: LT-37919 - разрулить некорректные данные на уровне стейта */
    !destinationValue.isTrip && (destinationValue.groupName === 'popularCountries' || destinationValue.groupName === 'allCountries' || destinationValue.groupName === 'countries')) {
      api === null || api === void 0 ? void 0 : api.getReferencesDepartureCities({
        to_country: destinationValue === null || destinationValue === void 0 ? void 0 : destinationValue.nameEn
      }) // @todo
      .then(function (availableDepartures) {
        if (isMounted()) {
          var updatedOptions = options.map(function (option) {
            return _objectSpread(_objectSpread({}, option), {}, {
              isClosed: !availableDepartures[option.id],
              destinationLabel: destinationValue === null || destinationValue === void 0 ? void 0 : destinationValue.nameRuForm3
            });
          });
          setOptionsWithAvailability(updatedOptions);
        }
      })["catch"](console.error);
    } else {
      setOptionsWithAvailability(options);
    }
  }, [destinationValue, isMobile, isMounted, options]);
  return {
    optionsWithAvailability: optionsWithAvailability
  };
};

exports.useFetchAvailableDepartures = useFetchAvailableDepartures;